<div *ngIf="blockedDocument" class="loader-container"></div>

<div class="dashboard-container widget-container">
  <router-outlet></router-outlet>
</div>

<ng-template #intercom></ng-template>
